import { setTenantIsStale } from 'actions/index';
import { connect } from 'react-redux';

import JSX from '../Branding';

const mapDispatchToProps = (dispatch) => ({
    setTenantIsStale: (tenantId) => dispatch(setTenantIsStale(tenantId))
});

export default connect(null, mapDispatchToProps)(JSX);
